module.exports = __webpack_public_path__ + "static/img/balz969-663-37083.d83bc2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balz969-663-37083.jpg
// module id = LZbz
// module chunks = 0